import React, { useEffect, useState } from 'react';
import RideCardSimple from '../components/RideCardSimple';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Carousel,
  Datepicker,
  Dropdown,
  Flowbite,
  Label,
  Select,
} from 'flowbite-react';
import { getAllRides, getUserInfo } from '../firebase/FirebaseManagement';
import {
  buttonTheme,
  datePickerTheme,
  dropDownTheme,
} from '../components/themes';
import gpsImage from '../images/gps-mobile.svg';
import navigationImage from '../images/navigation.svg';
import winterRoadImage from '../images/winter-road.svg';
import airportImage from '../images/airport.svg';
import reserveRideImage from '../images/reserve-ride.svg';
import Footer from '../components/Footer';

export default function Home() {
  const navigate = useNavigate();

  // Get all rides
  const [ridesDetails, setRidesDetails] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [departureFilter, setDepartureFilter] = useState();
  const [destinationFilter, setDestinationFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);

  const [filters, setFilters] = useState();

  useEffect(() => {
    const fetchRides = async () => {
      const rides = await getAllRides();
      setRidesDetails(rides);
    };

    fetchRides();
  }, []);

  const searchRides = () => {
    const urlQuery = `/allrexrides?departure=${departureFilter}&destination=${destinationFilter}&date=${dateFilter}`;
    navigate(urlQuery);
  };

  return (
    <div className="flex flex-col h-screen">
      <div className="md:flex-1 md:flex">
        <div className="md:w-1/3">
        <Carousel className="md:w-[450px] w-full h-[400px] md:mt-[25%]" indicators={false} leftControl={null}>

            <img alt="gpsImage" src={gpsImage} />
            <img alt="navigation" src={navigationImage} />
            <img alt="winter-road" src={winterRoadImage} />
            <img alt="airportImage" src={airportImage} />
            <img alt="reserveRideImage" src={reserveRideImage} />
          </Carousel>
        </div>
        <div className="md:w-1/3 flex flex-col justify-center items-center w-auto">
          <div className="box-container w-full md:w-[450px]">
            <h2 className="mb-3">Search for Rides</h2>
            <div>
              <Label value="Location" htmlFor="location"></Label>
              <Select id="location" onChange={(e) => setDepartureFilter(e.target.value)}>
                <option value={null} selected>
                  Select location
                </option>
                <option>Rexburg</option>
                <option>Idaho Falls</option>
                <option>Salt Lake City</option>
                <option>Ogden</option>
                <option>Provo</option>
                <option>Orem</option>
              </Select>
            </div>
            <div>
              <Label value="Destination" htmlFor="destination" className="mt-4"></Label>
              <Select id="destination" onChange={(e) => setDestinationFilter(e.target.value)}>
                <option value={null} selected>
                  Select Destination
                </option>
                <option>Rexburg</option>
                <option>Idaho Falls</option>
                <option>Salt Lake City</option>
                <option>Ogden</option>
                <option>Provo</option>
                <option>Orem</option>
              </Select>
            </div>

            <div>
              <Flowbite theme={{ theme: datePickerTheme }}>
                <Label>Date</Label>
                <Datepicker onSelectedDateChanged={(e) => setDateFilter(e)} />
              </Flowbite>
            </div>
            <Flowbite theme={{ theme: buttonTheme }}>
              <Button color="primary" className="w-full" onClick={() => searchRides()}>
                Search for Rides
              </Button>
            </Flowbite>
          </div>
        </div>
        <div className="md:w-1/3 pt-10">
          <div className="box-container ">
            <h2 className="mb-3 font-semibold ">Suggested Rex Rides</h2>
            <div className="suggested-rides-container" style={{ maxHeight: '60vh', overflowY: 'auto', width: '100%' }}>
              {ridesDetails?.map((rideDetail, index) => {
                return (
                  <div
                    className="mb-4"
                    index={index}
                    onClick={() => navigate(`./rexridecheckout/${rideDetail.id}`)}
                  >
                    <RideCardSimple key={index} rideDetails={rideDetail} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
